export class ApiError extends Error {
  constructor(status, code, message) {
    super(message || code);
    this.status = status;
    this.code = code;
  }
}

export class Api {
  constructor(baseUrl) {
    this.base = String(baseUrl || '').replace(/\/+$/, '');
    this.token = null;
    this.userId = null;
  }

  async request(path, { method = 'GET', body, auth = true } = {}) {
    const headers = { 'content-type': 'application/json' };
    if (auth && this.token) headers.authorization = `Bearer ${this.token}`;
    let res;
    try {
      res = await fetch(this.base + path, { method, headers, body: body ? JSON.stringify(body) : undefined });
    } catch (e) {
      throw new ApiError(0, 'network', '无法连接服务器：' + e.message);
    }
    const text = await res.text();
    let data = null;
    try {
      data = text ? JSON.parse(text) : null;
    } catch {
      data = { message: text };
    }
    if (!res.ok) throw new ApiError(res.status, data?.error || 'http_error', data?.message || `HTTP ${res.status}`);
    return data;
  }

  account(username) {
    return this.request(`/v1/account?username=${encodeURIComponent(username)}`, { auth: false });
  }

  register({ username, authKey, salt, kdf }) {
    return this.request('/v1/register', { method: 'POST', auth: false, body: { username, authKey, salt, kdf } });
  }

  login({ username, authKey }) {
    return this.request('/v1/login', { method: 'POST', auth: false, body: { username, authKey } });
  }

  sign(method, key) {
    return this.request(`/v1/sign/${method}`, { method: 'POST', body: { key } });
  }

  signPut(key) {
    return this.sign('put', key);
  }

  signGet(key) {
    return this.sign('get', key);
  }

  signDelete(key) {
    return this.sign('delete', key);
  }
}
